import { jsx as _jsx } from "react/jsx-runtime";
import ThumbnailIconBox from "./box/ThumbnailIconBox.js";
import Thumbnail from "./Thumbnail.js";
export default function ThumbnailRender(props) {
    const index = props.index ?? 0;
    const thumbnails = [props.thumbnails].flat();
    const selected = thumbnails.at(index);
    if (selected === undefined) {
        throw new Error("Could not find thumbnail at index " + index + ".");
    }
    if (selected.type === "thumbnail") {
        return _jsx(Thumbnail, { ...props.options, file: selected.file, neighbors: thumbnails, index: index });
    }
    else {
        return _jsx(ThumbnailIconBox, { ...props.options, icon: selected.icon, iconText: selected.text });
    }
}
